import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { redirect, useLoaderData } from "react-router";
import { getStripeOrder } from "../../lib/api";
import { IAPIResponse, IOrder } from "../../types/api";
import ProductDetails from "../../components/ProductDetails";
import "../../assets/css/majorybl/pages/register.scss";

export const loader = async () => {
    const paymentIntent = new URLSearchParams(window.location.search).get(
        "payment_intent",
    ) as string;

    if (!paymentIntent) {
        return redirect("/");
    } else {
        return await getStripeOrder(paymentIntent);
    }
};
const ThankYou = (): React.JSX.Element => {
    const { paymentStatus, order } = useLoaderData() as IAPIResponse & {
        paymentStatus: string;
        order: IOrder;
    };

    let header = "";
    switch (paymentStatus) {
        case "succeeded":
            header = "Checkout complete!";
            break;
        case "proccessing":
            header = "Your payment is processing";
            break;
        default:
            header = "Thank you for your order";
            break;
    }

    return (
        <Container className="py-5 thankYou">
            <Row>
                <Col md={6}>
                    <h2>{header}</h2>
                    <br />
                    <h3>Order Details:</h3>
                    {order.products
                        ? order.products.map((p, idx) => (
                              <ProductDetails
                                  product={p}
                                  orderNumber={order.id}
                                  key={idx}
                              />
                          ))
                        : ""}
                </Col>
            </Row>
        </Container>
    );
};

export default ThankYou;
